import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tab, Tabs } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import {
    useAppSelector, useAppDispatch, WatchedTabs, WatchedTabsTypes, PrivateRoutes, getRouterParams, DRIVE_MANAGER_STATE, DriveErrorMessages,
    WatchedTabTitles
} from "src/common";
import { CoverTemplate, Loading } from "src/components";
import { EmailFrequencyForm, WatchedActivity, WatchedManager, EmptyMessage } from ".";
import { uiActions, driveActions, WebsocketStatus } from "src/store";
import { RootState } from "src/store/configureStore";

function WatchedWrapperComponent() {
    const { collection_id, id } = useParams();
    const navigate = useNavigate();
    const is_loading = useAppSelector((state: RootState) => state.drive.is_loading);
    const drive_state = useAppSelector((state: RootState) => state.drive.drive_state);
    const ws_status = useAppSelector((state: RootState) => state.websocket.drive_watch_ws_status);
    const current_account = useAppSelector((state: RootState) => state.account.current_account);
    const [tab_key, setTabKey] = useState<WatchedTabsTypes>();
    const [websocket_ready, setWebsocketReady] = useState<boolean>(ws_status === WebsocketStatus.connected);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const is_events = (collection_id === WatchedTabs.events || !collection_id);
        is_events ?
            setTabKey(WatchedTabs.events) :
            setTabKey(WatchedTabs.root);
        resetStore();
        const title = is_events ? WatchedTabTitles.events : WatchedTabTitles.root;
        dispatch(uiActions.handleSetDocumentTitle(`${title} - ${current_account?.user_id}`));
    }, [collection_id, id]);

    useEffect(() => {
        setWebsocketReady(ws_status === WebsocketStatus.connected);
    }, [ws_status]);

    // Description: Reset sort, pagination and filters on navigation
    function resetStore() {
        dispatch(driveActions.resetPagination());
        dispatch(driveActions.resetSort());
        dispatch(driveActions.resetBreadcrumbs());
        dispatch(uiActions.handleMessageDismiss());
    }

    return <CoverTemplate
        className={`watched-component${is_loading ? " isloading" : ""}`}>
        {
            (!!current_account && drive_state === DRIVE_MANAGER_STATE.READY && websocket_ready) ?
                <>
                    <EmailFrequencyForm current_account={current_account} />
                    <Tabs id="folder=notification-tabs"
                        activeKey={tab_key}
                        onSelect={(k) => {
                            // NOTE: Use navigation to allow users to bookmark one or the other
                            navigate(`/drive/${PrivateRoutes.watched_route}${k === WatchedTabs.root ? `/${WatchedTabs.root}` : ""}`);
                        }}>
                        <Tab eventKey={WatchedTabs.events} title={WatchedTabTitles.events}>
                            {
                                tab_key === WatchedTabs.events &&
                                <WatchedActivity current_account={current_account} />
                            }
                        </Tab>
                        <Tab eventKey={WatchedTabs.root} title={WatchedTabTitles.root}>
                            {
                                tab_key === WatchedTabs.root &&
                                <WatchedManager
                                    current_account={current_account}
                                    router_params={getRouterParams({ collection_id, id })} />
                            }
                        </Tab>
                    </Tabs>
                </> :
                <Loading />
        }
        {
            (drive_state === DRIVE_MANAGER_STATE.ERROR) && <EmptyMessage message={DriveErrorMessages.default} />
        }
        <Tooltip
            id="tb-tooltip"
            disableStyleInjection="core"
            closeEvents={{
                mouseleave: true,
                blur: true,
                click: true,
                dblclick: true,
                mouseup: true,
            }} />
    </CoverTemplate>;
}

export default React.memo(WatchedWrapperComponent);
